const sectionSocialCommentCss = `
[data-type='section-social-comment'] .social-comment-wrapper {
  padding-block: 40px;
  background-color: var(--background-color, #ffffff);
}

[data-type='section-social-comment'] .social-comment-title h1,
[data-type='section-social-comment'] .social-comment-title h2,
[data-type='section-social-comment'] .social-comment-title h3 {
  font-size: 24px;
  line-height: normal;
  margin: 0 0 16px 0 !important;
}

[data-type='section-social-comment'] .social-comment-title h1:last-child,
[data-type='section-social-comment'] .social-comment-title h2:last-child,
[data-type='section-social-comment'] .social-comment-title h3:last-child {
  margin-bottom: 0 !important;
}

[data-type='section-social-comment'] .social-comment-title p {
  font-size: 16px;
  margin-bottom: 12px !important;
}

[data-type='section-social-comment'] .social-comment-title p:last-child {
  margin-bottom: 0 !important;
}

[data-type='section-social-comment'] .social-comment-textarea {
  resize: none;
  border: 1px solid var(--textarea-border-color, #d9d9d9);
  border-radius: 8px;
  padding: 16px;
  height: 112px;
  width: 100%;
  margin-top: 20px;
  outline: none;
}

[data-type='section-social-comment'] .comment-replies {
  margin-top: 16px !important;
  gap: 16px !important;
  border-left: 1px solid var(--reply-border-color, #9ca3af);
  padding-left: 8px;
}

[data-type='section-social-comment'] .comment-replies .comment-item .comment-avatar {
  width: 36px !important;
  height: 36px !important;
}

[data-type='section-social-comment'] .comments-list,
[data-type='section-social-comment'] .comment-replies {
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin-top: 20px;
}

[data-type='section-social-comment'] .comments-list .comment-item,
[data-type='section-social-comment'] .comment-replies .comment-item {
  display: flex;
  gap: 12px;
}

[data-type='section-social-comment'] .comments-list .comment-item .comment-avatar,
[data-type='section-social-comment'] .comment-replies .comment-item .comment-avatar {
  width: 48px;
  height: 48px;
  border-radius: 50%;
}

[data-type='section-social-comment'] .comments-list .comment-item .comment-avatar img,
[data-type='section-social-comment'] .comment-replies .comment-item .comment-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
}

[data-type='section-social-comment'] .comments-list .comment-item .comment-info,
[data-type='section-social-comment'] .comment-replies .comment-item .comment-info {
  flex: 1;
}

[data-type='section-social-comment'] .comments-list .comment-item .comment-info .comment-author-name,
[data-type='section-social-comment'] .comment-replies .comment-item .comment-info .comment-author-name {
  color: var(--author-name-color, #3b5998);
  margin: 0 !important;
  line-height: normal !important;
  font-weight: 700 !important;
}

[data-type='section-social-comment'] .comments-list .comment-item .comment-info .comment-content,
[data-type='section-social-comment'] .comment-replies .comment-item .comment-info .comment-content {
  margin-top: 2px;
  line-height: normal !important;
  color: var(--text-color, #000000);
}

[data-type='section-social-comment'] .comments-list .comment-item .comment-info .comment-action,
[data-type='section-social-comment'] .comment-replies .comment-item .comment-info .comment-action {
  margin-top: 8px;
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
}

[data-type='section-social-comment'] .comments-list .comment-item .comment-info .comment-action .comment-action-like-text,
[data-type='section-social-comment'] .comments-list .comment-item .comment-info .comment-action .comment-action-reply-text,
[data-type='section-social-comment'] .comment-replies .comment-item .comment-info .comment-action .comment-action-like-text,
[data-type='section-social-comment'] .comment-replies .comment-item .comment-info .comment-action .comment-action-reply-text {
  font-size: 15px;
  color: var(--action-color, #2563eb);
}

[data-type='section-social-comment'] .comments-list .comment-item .comment-info .comment-action .comment-action-reaction,
[data-type='section-social-comment'] .comment-replies .comment-item .comment-info .comment-action .comment-action-reaction {
  display: flex;
  align-items: center;
  gap: 4px;
}

[data-type='section-social-comment'] .comments-list .comment-item .comment-info .comment-action .comment-action-reaction .comment-action-like-icon,
[data-type='section-social-comment'] .comment-replies .comment-item .comment-info .comment-action .comment-action-reaction .comment-action-like-icon {
  fill: var(--action-color, #2563eb);
  color: var(--action-color, #2563eb);
  width: 18px;
  height: 18px;
}

[data-type='section-social-comment'] .comments-list .comment-item .comment-info .comment-action .comment-action-reaction span,
[data-type='section-social-comment'] .comment-replies .comment-item .comment-info .comment-action .comment-action-reaction span {
  opacity: 0.7;
  font-size: 15px;
  color: var(--text-color, #000000);
}

[data-type='section-social-comment'] .comments-list .comment-item .comment-info .comment-action .comment-date,
[data-type='section-social-comment'] .comment-replies .comment-item .comment-info .comment-action .comment-date {
  opacity: 0.7;
  font-size: 15px;
  color: var(--text-color, #000000);
}

@container (max-width: 768px) {
  [data-type='section-social-comment'] .social-comment-wrapper {
    padding-block: 16px;
  }

  [data-type='section-social-comment'] .social-comment-title h1,
  [data-type='section-social-comment'] .social-comment-title h2,
  [data-type='section-social-comment'] .social-comment-title h3 {
    font-size: 20px;
    line-height: 24px;
  }

  [data-type='section-social-comment'] .social-comment-title p {
    font-size: 14px;
  }

  [data-type='section-social-comment'] .comment-replies {
    margin-top: 12px;
    gap: 12px;
  }

  [data-type='section-social-comment'] .comments-list,
  [data-type='section-social-comment'] .comment-replies {
    font-size: 16px;
    margin-top: 16px;
  }
}
`;
export default sectionSocialCommentCss;
